module.exports = __webpack_public_path__ + "img/border.b2e6ac44.png";